export default "__VITE_ASSET__B_Ugx8C___"